import { render } from "./Publication.vue?vue&type=template&id=275ee13c&scoped=true"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"

import "./Publication.vue?vue&type=style&index=0&id=275ee13c&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_cts_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275ee13c"]])

export default __exports__